const e = "cmp", t = otto[e], {
  allowAll: n,
  rejectAll: o,
  togglePreferenceCenter: s,
  rejectGeneralVendorConsent: c,
  getConsentForGV: r,
  readVendorsConsents: C,
  archiveReceipt: g,
  emitConsentChangeEvent: a,
  setLegacyCBCookie: l,
  getOttoOwnPurposesConsent: p,
  getAppGoogleTrackingConsent: i,
  getAdjustTrackingConsent: A,
  consentChanged: d
} = otto.cmp;
export {
  e as NEXUS_CMP_NAMESPACE,
  n as allowAll,
  g as archiveReceipt,
  t as cmp,
  d as consentChanged,
  a as emitConsentChangeEvent,
  A as getAdjustTrackingConsent,
  i as getAppGoogleTrackingConsent,
  r as getConsentForGV,
  p as getOttoOwnPurposesConsent,
  C as readVendorsConsents,
  o as rejectAll,
  c as rejectGeneralVendorConsent,
  l as setLegacyCBCookie,
  s as togglePreferenceCenter
};
